import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=18cc8d4e"
import script from "./TabsList.vue?vue&type=script&lang=js"
export * from "./TabsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports